import React from "react";

const WhyChoose = () => {
  return (
    <div className="wcu-area-2 ">
      <div className="container">
  <div className="row justify-content-center">
    <div className="col-lg-8">
      <div className="title-area text-center me-xl-4 ms-xl-4">
        <span className="sub-title">
          <img src="assets/img/icon/title_left.svg" alt="Ícone Nossa Expertise Rocvel" />
          Nossa Expertise
        </span>
        <h2 className="sec-title style2">
          Especialistas no segmento alimentício: soluções estratégicas para restaurantes, cozinhas e indústrias.
        </h2>
      </div>
    </div>
  </div>
</div>
      <div className="container">
        <div className="row align-items-center">
          <div className="col-xl-6">
            <div className="wcu-thumb">
              <div className="wcu-thumb-1">
                <img src="assets/img/home/7.png" alt="Especialistas em RH Grupo Rocvel" />
              </div>
            </div>
          </div>
          <div className="col-xl-6">
            <div className="wcu-card-wrap">
              <div className="wcu-card">
                <div className="icon">
                  <img src="assets/img/home/8/1.png" alt="Corporativo e Administrativo" />
                </div>
                <div className="wcu-card-details">
                  <h4 className="wcu-card-title">
                    Corporativo & Administrativo
                  </h4>
                  <p className="wcu-card-text">
                    Estruturação técnica para setores administrativos e operações corporativas complexas.
                  </p>
                </div>
              </div>
              <div className="wcu-card">
                <div className="icon">
                  <img src="assets/img/home/8/2.png" alt="Varejo, Redes e Franquias" />
                </div>
                <div className="wcu-card-details">
                  <h4 className="wcu-card-title">
                    Varejo, Redes & Franquias
                  </h4>
                  <p className="wcu-card-text">
                    Atendimento ágil voltado para a expansão acelerada de pontos de venda e redes comerciais.
                  </p>
                </div>
              </div>
              <div className="wcu-card">
  <div className="icon">
    {/* Dica: Pode ser interessante trocar o arquivo da imagem para um ícone mais voltado ao setor alimentício depois */}
    <img src="assets/img/home/8/3.png" alt="Indústria Alimentícia" />
  </div>
  <div className="wcu-card-details">
    <h4 className="wcu-card-title">
      Indústria Alimentícia
    </h4>
    <p className="wcu-card-text">
      Precisão cirúrgica no recrutamento e alocação de equipes operacionais especializadas para o setor alimentício.
    </p>
  </div>
</div>
              <div className="wcu-card">
                <div className="icon">
                  <img src="assets/img/home/8/4.png" alt="Setores em Expansão" />
                </div>
                <div className="wcu-card-details">
                  <h4 className="wcu-card-title">
                    Setores em Expansão
                  </h4>
                  <p className="wcu-card-text">
                    Metodologia flexível para empresas de todos os portes que buscam crescimento estruturado.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WhyChoose;